import { LoadablePaint } from '@confluence/loadable';

export const PageIncludeMacroHandler = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageIncludeMacro" */ '../src/PageIncludeMacroRenderer.tsx'
			)
		).PageIncludeMacroRenderer,
});
